import {
    AnyAction,
    CaseReducer,
} from '@reduxjs/toolkit'
import {
    NinchatProperties,
    NinchatState,
} from 'api/types'
import {
    extractProperties,
    isEmpty,
} from '.'
import {NinchatAudienceRangeCommentContentsEvent} from '../types/events'

const getLoadedEmptyComments = (
    state: NinchatState,
    action: AnyAction,
    queueId: NinchatProperties.QueueID,
): NinchatProperties.NinchatAudienceRangeComments => {
    const {
        audience_first: audienceFirst,
        audience_last: requestedAudienceLast,
    } = action.meta?.arg ?? {}
    const audienceLast = requestedAudienceLast ?? audienceFirst

    if (!audienceFirst || !audienceLast) {
        return {}
    }

    const audienceMin = audienceFirst < audienceLast ? audienceFirst : audienceLast
    const audienceMax = audienceFirst > audienceLast ? audienceFirst : audienceLast

    return (state._user_queues_activity[queueId] || [])
        .filter((activity) => activity.event === 'audience_complete' && activity.audience_id)
        .filter((activity) => {
            const audienceId = activity.audience_id as NinchatProperties.AudienceID
            return audienceId >= audienceMin && audienceId <= audienceMax
        })
        .reduce<NinchatProperties.NinchatAudienceRangeComments>((comments, activity) => ({
            ...comments ?? [],
            [activity.audience_id as NinchatProperties.AudienceID]: [],
        }), {})
}

export const audienceRangeCommentContents: CaseReducer<NinchatState, AnyAction> = (state, action) => {
    const {
        queue_id,
        audience_range_comments,
        ...rest
    } = extractProperties<NinchatAudienceRangeCommentContentsEvent>(action.payload)

    isEmpty(rest)

    state._user_audience_comments[queue_id] = {
        ...state._user_audience_comments[queue_id],
        ...getLoadedEmptyComments(state, action, queue_id),
        ...audience_range_comments,
    }
}
